<template>
  <ModalBase @closed="emit('closed')" :closeBtn="true" :full="true">
    <div class="wrapper">
      <HtmlContent class="article" :html="html" />
    </div>
  </ModalBase>
</template>

<script setup>
const props = defineProps(["html"]);
const emit = defineEmits(["closed"]);
</script>
